/**
 * 当前会话分享人员卡片
 */
import lodashGet from "lodash/get";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import { UserModel } from "@/models/user";
import { message as toast } from "antd";
import { Employee, Session } from "@/types/chat";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { SelectorMode, UserSelTab } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { buildTemplate2MessageBody, employeeToUid } from "@/utils/chat/message";
import { ListItemData } from "@/components/ListItem";
import lodashCompact from "lodash/compact";

function useShareUserCardInChat({
  currentEmployee,
  selectedSession,
  userData
}: {
  currentEmployee: Employee;
  selectedSession: Session;
  userData: UserModel;
}) {
  const { t } = useTranslation("chat");
  const limit_number = 10;
  const { imService } = useContext<GlobalContextConfig>(GlobalContext);
  // 分享的卡片的信息
  const getShareCardInfo = (userCardData: any) => {
    const dealData = {
      ...userCardData,
      ...userCardData?.origin?.info
    };
    return [
      {
        type: 1,
        sharecard: {
          accountType: dealData.accountTpe,
          pin: dealData.userId,
          teamId: dealData.teamId,
          app: dealData?.appId || dealData?.app,
          avatar: dealData?.avatar,
          nickName: dealData?.name,
          realName: dealData?.name
        }
      }
    ];
  };
  // 消息体
  const getShareCardMessageBody = (selectedData: any): any => {
    const cardInfo = getShareCardInfo(selectedData);
    const data = {
      nativeId: "share_card",
      data: cardInfo,
      currentEmployee,
      id: generateMessageId()
    };
    return buildTemplate2MessageBody(data);
  };
  // 调起人员选择器
  const openSelector = () => {
    openUserSelectionDefaultModal(
      {
        title: t("select-contacts"),
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        mode: SelectorMode.user,
        tabs: ["recent"],
        tabSort: [{ tab: UserSelTab.recent, sort: 1 }],
        maxSelectedNum: limit_number,
        validate(data) {
          return new Promise((resolve, reject) => {
            const list = lodashGet(data, "data.result", []);
            if (list.length > limit_number) {
              toast.warning(`最多支持选择${limit_number}个人`);
              return false;
            }
            resolve();
          });
        }
      },
      (data, close) => {
        // 发送消息
        const selectedData = lodashGet(data, "data.result", []) as ListItemData[];
        const compactData = lodashCompact(selectedData);
        for (let item of compactData) {
          const messageId = generateMessageId();
          const body = getShareCardMessageBody(item);
          imService.sendChatMessage(selectedSession.sessionId, messageId, {
            ...body,
            id: messageId
          });
        }
        close();
        toast.success("分享成功");
      },
      userData
    );
  };
  return openSelector;
}

export default useShareUserCardInChat;
